<template>
  <div>
    <p v-for="line in storyLine.lines" :key="line.index" class="story-text-style">{{ line }}</p>

    <section v-if="userChoice[0] == 'father'" class="story-text-style story-button-container">
      <button class="story-btn-style" @click="navigateTo('ask', true, 'Courageous')">Ask</button>
      <button class="story-btn-style" @click="navigateTo('notAsk', false)">Don't Ask</button>
    </section>

    <section v-if="userChoice[0] == 'mother'" class="story-text-style story-button-container">
      <button class="story-btn-style" @click="skipToFour('none')">Proceed</button>
    </section>
  </div>
</template>

<script>
export default {
  name: "Story-Two",
  data() {
    return {
      userTrait: this.$store.state.userPersonality,
      userChoice: this.$store.state.userChoices
    };
  },
  computed: {
    storyLine() {
      return this.$store.state.Two[this.userChoice[0]];
    }
  },
  methods: {
    skipToFour(choice) {
      for (let i = 0; i < 2; i++) {
        this.$store.dispatch("updateChoice", choice);
      }
      this.$store.commit("setModalDisplay", {
        display: true,
        isGranted: true,
        url: "/story/four"
      });
    },
    navigateTo(choice, isTraitRequired, trait) {
      let checkAccess, deniedReason;
      if (isTraitRequired) {
        if (this.userTrait.indexOf(trait) > -1) {
          checkAccess = true;
          this.$store.dispatch("updateChoice", choice);
        } else {
          checkAccess = false;
          deniedReason = `You don't have the particular trait: ${trait}`;
        }
        this.$store.commit("setModalDisplay", {
          display: true,
          isGranted: checkAccess,
          deniedReason,
          url: "/story/three"
        });
      } else {
        this.$store.dispatch("updateChoice", choice);
        this.$store.commit("setModalDisplay", {
          display: true,
          isGranted: true,
          url: "/story/three"
        });
      }
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/css/Scheme.scss";
</style>
